import { useParams } from "react-router-dom";
import { ProductOfferingConfigsPageView } from "src/routes/libraries/product-offering-configs/ProductOfferingConfigsPage";
import { DevelopmentParams } from "src/routes/routesDef";

export function ProductOfferingConfigsPage() {
  const { developmentId } = useParams<DevelopmentParams>();
  return <ProductOfferingConfigsPageView marketsOrIds={{ developmentId }} />;
}
